import styled from 'styled-components';

export const VideoGridContainer = styled.div`
  padding-top: 15px;
  img {
    width: 100%;
  }
  .heading {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    padding-top: 18px;
  }
  video {
    width: 100%;
  }
`;
